import React, { useMemo } from "react";
import clsx from "clsx";

import { IActiveLearningIssue } from "../../../../../../state";
import TextInput from "../../../../../../atoms/ActiveLearning/TextInput";
import styles from "../../../ActiveLearningIssue.module.scss";
import { ReactComponent as IconLive } from "../../../../../../assets/images/ActiveLearning/icon_live.svg";
import hintImage18 from "../../../../../../assets/images/ActiveLearning/hint/img_18.webp";

type Issue3MaterialProps = {
  issue?: IActiveLearningIssue;
};

export const Issue3Material = (props: Issue3MaterialProps) => {
  const question1 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 1);
  }, [props.issue?.questions]);

  return (
    <div className={styles.issue}>
      <div className={styles.header}>
        <span className={styles.no}>
          WORK
          {props.issue?.no && props.issue?.no < 10
            ? `0${props.issue?.no}`
            : props.issue?.no}
        </span>
        <p className={styles.title}>{props.issue?.title}</p>
        <p className={styles.read}>
          WORK02では、社会で価値を生み出す事例を知った。グループワークで得た周りの意見を参考にして、これから取り組んでいく「問い」の原型を考えてみよう。
          <br />
          「問い」は次回のLessonで具体的にしていくので、今は自分の考えたいこと/やってみたいと思ったことを素直に入力しよう。
        </p>
      </div>
      {question1 && <TextInput />}
      <div className={clsx(styles.card, styles.row)}>
        <div className={styles.wrapper}>
          <div className={styles.block}>
            <p className={styles.label}>
              <IconLive />
              POINT
            </p>
            <p className={styles.title}>「問い」とは？</p>
            <p className={styles.text}>
              探究学習における「問い」とは、『「自分だったらこうしたい」を実現するためにはどうしたら良いのだろう？』という、自分が「こうしたい」「
              考えたい」「 解決したい」という想いを含んだ問いかけのこと。
              <br />
              「問い」を設定することで、自分の願いを実現するための第一歩を踏み出すことができる。
            </p>
          </div>
          <div className={styles.block}>
            <img
              className={styles.hintImage}
              src={hintImage18}
              alt="「問い」とは？"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Issue3Material;
